
<template>
  <v-card>
    <!-- <mrc_ess_iconGroup
      :is_disabled="disabled"
      :showEdit="hasBtn('edit-role')"
      :show_del="hasBtn('delete-role')"
      @handleEdit="handleEdit"
      @handleDel="handleDel"
    ></mrc_ess_iconGroup> -->
    <v-card-text>
      <v-row>
        <mrc_ess_bulkFile
          @changeFile="changeFile"
          v-if="fileInfo.length <= 0"
        ></mrc_ess_bulkFile>
        <v-col cols="12">
          <div
            v-for="(item, index) in fileInfo"
            class="d-flex justify-space-between align-center"
            :key="index"
          >
            <div>
              <mrc_ess_svgIcon
                :iconClass="'filetype-' + suffix(item.name)"
                style="font-size: 23px"
              />
              <span class="mx-1">{{ item.file_name }}</span>
              <span>({{ item.size }}KB)</span>
            </div>
            <div>
              <v-icon
                class="material-icons"
                @click="download(item, index)"
                style="font-size: 28px"
                >arrow_downward</v-icon
              >
              <v-icon
                v-show="!disabled"
                class="material-icons"
                @click="deleteviewfile(item, index)"
                style="font-size: 28px"
                >delete</v-icon
              >
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
    <mrc_ess_submitBtn
      @cancel="cancel"
      @success="success"
      v-if="!disabled"
      :loading="loading"
      :cancelText="cancelText || $t('label_cancel')"
      :successText="successText || $t('label_submit')"
    ></mrc_ess_submitBtn>
  </v-card>
</template>
<script>
import { findSrc } from "@/service/api/upload.js";
import { add_file, del_file } from "@/service/api/file";
export default {
  props: {
    cancelText: {
      type: String,
    },
    successText: {
      type: String,
    },
  },
  data() {
    return {
      fileInfo: [],
      disabled: false,
      loading: false,
      urlList: [],
      file_uuid: "",
      listuuid: "",
      file_name: "",
      url: "",
      attachments_uuid: "",
    };
  },
  watch: {
    disabled: {
      handler(v) {
        if (!this.$store.state.uuid) return;
        if (!v) {
          this.$route.meta.title = "label_001-018_001-017-003_lable_edit_file";
          this.$store.commit(
            "set_page_title",
            "label_001-018_001-017-003_lable_edit_file"
          );
        } else {
          this.$route.meta.title = "label_001-018_001-017-003_viewFile";
          this.$store.commit(
            "set_page_title",
            "label_001-018_001-017-003_viewFile"
          );
        }
      },
      immediate: true,
    },
  },
  methods: {
    download(val) {
      const links = document.createElement("a");
      // let blob = new Blob([res], { type: 'application/vnd.ms-excel' });
      links.style.display = "none";
      //设置连接
      links.href = val.path;
      links.download = val.name;
      document.body.appendChild(links);
      //模拟点击事件
      links.click();
      document.body.removeChild(links);
    },
    handleDel() {
      this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
        .then(async () => {
          var del = await del_file({
            uuid: this.listuuid,
            file_name: this.file_name,
          });
          if (del.code == 200) {
            this.$deleteFile(this.fileInfo[0].uuid);
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            });
            this.$router.go(-1);
          }
        })
        .catch(() => {});
    },
    handleEdit() {
      this.disabled = !this.disabled;
    },
    suffix(val) {
      return val.slice(val.indexOf(".") + 1);
    },
    cancel() {
      this.$router.go(-1); //返回上一级
      this.loading = false;
    },
    changeFile(v) {
      this.fileInfo.push(v);
    },
    deleteviewfile(val, index) {
      this.fileInfo.splice(index, 1);
    },
    async delFile(list) {
      var del = await del_file({
        uuid: list.uuid,
        file_name: list.file_name,
      });
      if (del.code == 200) {
        this.$deleteFile(list.uuid);
      }
    },
    async success() {
      this.loading = true;
      //对文件进行处理
      var list = {
        uuid: this.listuuid,
        file_name: this.file_name,
        url: this.fileInfo[0].path,
      };

      await this.delFile(list);

      let fileuuids = await this.uploadFilesMore();

      if (fileuuids != undefined && fileuuids != "") {
        let filename = this.fileInfo[0].name;

        var res = await add_file({
          directory_uuid: this.file_uuid,
          file_name: filename,
          attachments_uuid: fileuuids[0],
          url: this.urlList[0],
        });

        if (res.code == 200) {
          this.$router.go(-1);
        }
      } else {
        this.$Message({ text: "上传失败" });
      }
      this.loading = false;
    },
    getDetail() {
      if (this.attachments_uuid) {
        findSrc({ uuid: this.attachments_uuid }).then((res) => {
          if (res.data.files.length > 0) {
            this.fileInfo = res.data.files;
          } else {
            this.fileInfo = [];
          }
        });
      }
    },
    async uploadFilesMore() {
      let fileuuids = [];
      for (let i = 0; i < this.fileInfo.length; i++) {
        const res = await this.$uploadFiles([this.fileInfo[i]], {
          module_uuid:'companydoc',
          function_uuid: this.$store.state.menuFunctionUuid,
          attachment_data_table: "mrbase_sys_document",
          attachment_data_field: "attachments_uuid",
          org_level_uuid: this.$store.state.currentCompany,
          uuid: this.$store.state.currentCompanyClientUuid,
        });
        if (typeof res == "object" && res != undefined && res.code == 200) {
          fileuuids.push(res.uuid);

          this.urlList.push(res.url);
        }
      }
      return fileuuids;
    },
  },
  async mounted() {
    if (!this.$store.state.iconstatus) {
      this.disabled = false;
    } else {
      this.disabled = true;
    }
    this.file_uuid = this.$route.query.file_uuid;
    this.file_name = this.$route.query.file_name;
    this.listuuid = this.$route.query.listuuid;
    this.attachments_uuid = this.$route.query.attachments_uuid;
    this.url = this.$route.query.url;
    await this.getDetail();
  },
};
</script>
